import { Link } from "react-router-dom";
import { FEATURED } from "@/mocks/articles";
import { categoryName } from "@/mocks/site";
import { Eyebrow } from "@/components/ui/primitives";

export default function FeaturedSpecial() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <Eyebrow text="深度专题" en="Features" />
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              值得慢慢读的幕后长文
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              不追热点，只追质感。制作特辑、导演访谈与创作者复盘，往往比正片更经得起反复回看。
            </p>
          </div>
          <Link
            to="/column?c=special"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-300 transition hover:text-primary-200"
          >
            进入制作特辑 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="flex flex-col gap-8">
          {FEATURED.map((a, idx) => (
            <article
              key={a.id}
              className={
                "grid overflow-hidden rounded-lg border border-background-200 bg-background-100 md:grid-cols-2 " +
                (idx % 2 === 1 ? "md:[&>*:first-child]:order-2" : "")
              }
            >
              <Link to={`/story/${a.slug}`} className="group relative block overflow-hidden">
                <img
                  src={a.hero}
                  alt={a.title}
                  className="h-64 w-full object-cover object-top transition duration-500 group-hover:scale-105 md:h-full md:min-h-[320px]"
                />
                <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-foreground-100">
                  {categoryName(a.category)}
                </span>
              </Link>
              <div className="flex flex-col justify-center p-6 md:p-10">
                <p className="text-xs tracking-[0.2em] text-primary-400 uppercase">
                  第 {String(idx + 1).padStart(2, "0")} 篇 · {categoryName(a.category)}
                </p>
                <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  <Link to={`/story/${a.slug}`} className="transition hover:text-primary-300">
                    {a.title}
                  </Link>
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-foreground-600">{a.excerpt}</p>
                <div className="mt-6 flex flex-wrap items-center gap-2">
                  {a.tags.map((t) => (
                    <span key={t} className="rounded-full border border-background-300 px-2.5 py-1 text-xs text-foreground-500">
                      {t}
                    </span>
                  ))}
                </div>
                <div className="mt-6 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="text-sm text-foreground-500">
                    <span className="text-foreground-800">{a.author}</span> · {a.authorRole}
                  </span>
                  <Link
                    to={`/story/${a.slug}`}
                    className="inline-flex items-center gap-1 text-sm font-medium text-primary-300 transition hover:text-primary-200"
                  >
                    开始阅读 <i className="ri-arrow-right-line" />
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}